require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-moenchhof.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-moenchhof");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-moenchhof!./.cache/json/betreuungseinrichtungen-neusiedl-moenchhof.json
// module id = 955
// module chunks = 231608221292675